import { SupportRequestObject } from '../../interfaces/APIInterface';
import './NotificationsChild.css'
import { useNavigate  } from "react-router-dom";
import { COSMOS_API, POST_ENDPOINT } from '../../api/API';
import { useContext, useState } from 'react';
import { AdminContext } from '../../contexts/AdminContext';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const CloseMFAButton = (props: any) => {
    const {adminCredentials, getToken} = useContext(AdminContext);
    const [sending, setSending] = useState<boolean>(false);

    async function resetMFAAndCloseRequest(supportRequest: SupportRequestObject) {
        setSending(true);

        const resetMFABody = {
            id: supportRequest.requesterId,
            country: supportRequest.country,
            applicationId: supportRequest.applicationId
        };
        const resetMFAResponse = await COSMOS_API.POST(resetMFABody, POST_ENDPOINT.ResetMFA, getToken());
        if (resetMFAResponse.ok) {
            setSending(false);
            return;
        }

        const closeRequestBody = {
            id: supportRequest.id,
            country: supportRequest.country,
            resolution: "MFA was successfully reset"
        };
        const closeRequestResponse = await COSMOS_API.POST(closeRequestBody, POST_ENDPOINT.CloseSupportRequest, getToken());
        if (closeRequestResponse.ok) {
            setSending(false);
        } else {
            props.callSupportRequestsAPI();
        }
    }

    return (
        <Button 
        variant='outlined'
            onClick={() => resetMFAAndCloseRequest(props.supportRequest)}
            disabled={sending}>
            {sending ? "Reseting MFA" : "Reset MFA and close request"}
        </Button>
    );
}

const CloseRequest = (props: any) => {
    const {adminCredentials, getToken} = useContext(AdminContext);
    const [sending, setSending] = useState<boolean>(false);

    async function closeRequest(supportRequest: SupportRequestObject) {
        setSending(true);

        const closeRequestBody = {
            id: supportRequest.id,
            country: supportRequest.country,
            resolution: ""
        };
        const closeRequestResponse = await COSMOS_API.POST(closeRequestBody, POST_ENDPOINT.CloseSupportRequest, getToken());
        if (closeRequestResponse.ok) {
            setSending(false);
        } else {
            props.callSupportRequestsAPI();
        }
    }

    return (
        <Button
        variant='outlined'
            onClick={() => closeRequest(props.supportRequest)}
            disabled={sending}>
            {sending ? "Closing request" : "Close request"}
        </Button>
    );
}

const SupportRequestChild = (props: any) => {
    let navigate = useNavigate();

    function GetTitle(title: string) {
        if (!title) {
            return "Unknown Support Request";
        }

        if (title.toLowerCase() === 'mfa') {
            return "MFA Reset";
        } else if (title.toLowerCase() === 'email') {
            return "Email Change";
        }

        return title;
    }

    function GetApplicationName(id: string) {
        const appName = props.allApplications[id];
        if (appName)
            return appName;

        return id;
    }

    function GetMessage(message: string) {
        if (message === "mfa") {
            return "This user would like to have their MFA number reset.";
        }

        return message;
    }

    function GoToUser(supportRequest: SupportRequestObject) {

        if (supportRequest.requesterId && supportRequest.country) {
            navigate({
                pathname: '/edit-user',
                search: 'user=' + supportRequest.requesterId + '&country=' + supportRequest.country
            });
        } else {
            let search = "";
            if (supportRequest.email) {
                search = "email=" + encodeURIComponent(supportRequest.email);
            } else if (supportRequest.name) {
                if (supportRequest.name.split(' ').length === 1) {
                    search = "firstName=" + supportRequest.name
                } else if (supportRequest.name.split(' ').length > 1) {
                    search = "firstName=" + encodeURIComponent(supportRequest.name.split(' ')[0]) +
                        "&lastName=" + encodeURIComponent(supportRequest.name.split(' ')[1]);
                }
            }

            navigate({
                pathname: '/search-users',
                search: search
            });
        }
    }

    function isMfaSupportRequest(supportRequest: SupportRequestObject) {
        return supportRequest.title === 'mfa' &&
            supportRequest.requesterId &&
            supportRequest.country;
    }

    return (
        <Card variant='outlined' >
            <CardContent>
                <Typography variant='h4'> Support Request | {GetTitle(props.supportRequest.title)}</Typography>
                <div>
                    <Typography variant='body1'>Application: {GetApplicationName(props.supportRequest.applicationId)}</Typography>
                    <Typography variant='body1'> Time: {new Date(props.supportRequest.createdAt * 1000).toLocaleString()} </Typography>
                    <Typography variant='body1'> User: {props.supportRequest.email}, {props.supportRequest.name} </Typography>
                    <Typography variant='body1'> {GetMessage(props.supportRequest.message)} </Typography>
    
                    <Button className="ack-note" onClick={() => GoToUser(props.supportRequest)}>Go to user</Button>
                    {isMfaSupportRequest(props.supportRequest) ?
                        <CloseMFAButton supportRequest={props.supportRequest} callSupportRequestsAPI={props.callSupportRequestsAPI} /> :
                        null
                    }
                    <CloseRequest supportRequest={props.supportRequest} callSupportRequestsAPI={props.callSupportRequestsAPI} />
                </div>
            </CardContent>
        </Card>
    )
}

export default SupportRequestChild
